import { render, staticRenderFns } from "./staffDetail.vue?vue&type=template&id=6e4d2890&scoped=true&"
import script from "./staffDetail.vue?vue&type=script&lang=js&"
export * from "./staffDetail.vue?vue&type=script&lang=js&"
import style0 from "./staffDetail.vue?vue&type=style&index=0&id=6e4d2890&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d2890",
  null
  
)

export default component.exports